"use strict";

exports.__esModule = true;
exports.pipeline = exports.compressImage = exports.exif = exports.imageInfo = exports.watermark = exports.imageMogr2 = exports.getUploadUrl = exports.filterParams = exports.getHeadersForMkFile = exports.getResumeUploadedSize = exports.getHeadersForChunkUpload = exports.createMkFileUrl = exports.region = exports.upload = undefined;

var _config = require("./config");

var _utils = require("./utils");

var _upload = require("./upload");

var _image = require("./image");

var _observable = require("./observable");

var _statisticsLog = require("./statisticsLog");

var _compress = require("./compress");

var _compress2 = _interopRequireDefault(_compress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var statisticsLogger = new _statisticsLog.StatisticsLogger();

function upload(file, key, token, putExtra, config) {

  var options = {
    file: file,
    key: key,
    token: token,
    putExtra: putExtra,
    config: config
  };

  return new _observable.Observable(function (observer) {
    var uploadManager = new _upload.UploadManager(options, {
      onData: function onData(e) {
        return observer.next(e);
      },
      onError: function onError(e) {
        return observer.error(e);
      },
      onComplete: function onComplete(e) {
        return observer.complete(e);
      }
    }, statisticsLogger);
    uploadManager.putFile();
    return uploadManager.stop.bind(uploadManager);
  });
}

exports.upload = upload;
exports.region = _config.region;
exports.createMkFileUrl = _utils.createMkFileUrl;
exports.getHeadersForChunkUpload = _utils.getHeadersForChunkUpload;
exports.getResumeUploadedSize = _utils.getResumeUploadedSize;
exports.getHeadersForMkFile = _utils.getHeadersForMkFile;
exports.filterParams = _utils.filterParams;
exports.getUploadUrl = _utils.getUploadUrl;
exports.imageMogr2 = _image.imageMogr2;
exports.watermark = _image.watermark;
exports.imageInfo = _image.imageInfo;
exports.exif = _image.exif;
exports.compressImage = _compress2["default"];
exports.pipeline = _image.pipeline;


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 58
// module chunks = 0